module.exports = __webpack_public_path__ + "assets/img/smsimg3.dee279b7.png";